// Central SEO metadata. Site is German-first; titles/topics stay English per brand rule.
import { PRODUCTS, getProduct } from "@/data/products";
import { CREATORS } from "@/data/site";

export const SITE_URL = "https://antiunhealthyclub.com";
export const SITE_NAME = "Anti Unhealthy Club";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/default.jpg`;

export const PAGE_SEO = {
  home: {
    path: "/",
    title: "Anti Unhealthy Club | Fight For Yourself",
    description:
      "Anti Unhealthy Club ist das Positivity-Movement für deine Gesundheit: Supplements, Merch und Community – laut, bunt und positiv. Fight for yourself.",
  },
  shop: {
    path: "/shop",
    title: "Supplements & Lifestyle | Anti Unhealthy Club",
    description:
      "Supplements im Standbodenbeutel, Merch-Drops und Accessoires: Entdecke alle Produkte von Anti Unhealthy Club – von Sugar Balance bis Club Megafon.",
  },
  movement: {
    path: "/movement",
    title: "Anti Unhealthy Club Movement | Body · Mind · Soul",
    description:
      "Das Movement: Warum Anti Unhealthy Club Gesundheit laut, bunt und positiv macht. Unser Manifest für Mindset, Motivation und Community.",
  },
  creators: {
    path: "/creators",
    title: "Creators | Anti Unhealthy Club",
    description:
      "Die Gesichter des Clubs: Creator:innen teilen ihre echten Routinen mit Anti Unhealthy Club – keine Werbung, echte Stories.",
  },
  lookbook: {
    path: "/lookbook",
    title: "Lookbook | Anti Unhealthy Club",
    description:
      "Das Lookbook zu Drop 01: Editorials mit Standbodenbeuteln, Merch-Pieces und der Community von Anti Unhealthy Club.",
  },
  bundle: {
    path: "/bundle",
    title: "Kit Builder | Anti Unhealthy Club",
    description:
      "Mixe dein Club-Kit aus Supplements und Merch und spare gestaffelt: 3 Pieces −10 %, 4 Pieces −15 %, ab 5 Pieces −20 %.",
  },
};

// Product SEO: title built from product name + main ingredients (supplements) or claim (merch).
export const getProductSeo = (id) => {
  const p = getProduct(id);
  if (!p) return null;
  const name = p.name.de;
  let title;
  if (p.category === "supplement") {
    const parts = p.ingredients.de.split("·").map((s) => s.trim()).slice(0, 3).join(", ");
    title = `${name} – ${parts} | ${SITE_NAME}`;
  } else {
    title = `${name} – ${p.claim.de} | ${SITE_NAME}`;
  }
  const suffix = p.soldOut
    ? "Bald zurück bei Anti Unhealthy Club."
    : `Jetzt bei Anti Unhealthy Club entdecken – ${p.price} €.`;
  const description = `${p.short.de} ${suffix}`;
  const clamp = (s) => (s.length > 165 ? s.slice(0, 162) + "…" : s);
  return {
    path: `/product/${p.id}`,
    title,
    description: clamp(description),
    image: productOgImage(p.id),
    product: p,
  };
};

export const getCreatorSeo = (slug) => {
  const c = CREATORS.find((x) => x.slug === slug);
  if (!c) return null;
  const clamp = (s) => (s.length > 165 ? s.slice(0, 162) + "…" : s);
  return {
    path: `/creator/${c.slug}`,
    title: `${c.name} (${c.handle}) | Creators | ${SITE_NAME}`,
    description: clamp(`${c.name} ist ${c.role.de} im Anti Unhealthy Club: „${c.quote.de}“ – die ganze Story und alle Reels.`),
    image: `${SITE_URL}/og/creator-${c.slug}.jpg`,
    creator: c,
  };
};

// OG image helper (some products have .jpg og images)
export const OG_IMAGE_EXT = {
  "auc-hoodie": "jpg",
  "auc-cap": "jpg",
  "auc-shaker": "jpg",
  "positivity-crew": "jpg",
  "auc-bucket": "jpg",
  "fight-poster": "jpg",
};

export const productOgImage = (id) => `${SITE_URL}/og/product-${id}.${OG_IMAGE_EXT[id] || "png"}`;

export const ALL_PRODUCT_IDS = PRODUCTS.map((p) => p.id);
